module.exports = __webpack_public_path__ + "static/media/ic-car@3x.4989ee04.png";